module.exports = __webpack_public_path__ + "img/product_11.5719032.webp";